"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iYtjListResponse = exports.iYtjResponse = void 0;
const t = require("io-ts");
const sok_types_1 = require("@caddigital/sok-types");
exports.iYtjResponse = t.union([
    t.interface({
        businessId: t.string,
        name: t.string
    }),
    t.partial({
        id: t.number,
        addressDetails: sok_types_1.AddressDetails.iAddressDetails
    })
]);
exports.iYtjListResponse = t.interface({
    totalResults: t.number,
    list: t.array(exports.iYtjResponse)
});
//# sourceMappingURL=ytj.js.map